export default __webpack_public_path__ + "static/media/one-call-away.34dd97e5.jpg";